import { DeliveryProvider, OFFER_KIND, PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  customer_info: {
    dummy_order: 'Pedido de prueba',
    ordered_at: 'Pedido a las:',
  },
  delivery_info: {
    info: 'Info de entrega:',
  },
  order_note: {
    label: 'Nota del pedido:',
  },
  schedule_info: {
    pickup: 'Recogida',
    delivery: 'Entrega',
    room_service_location: {
      room_service: 'Habitación',
      table_service: 'Mesa',
    },
    wish_time: 'Hora deseada:',
    confirmed_time: 'Hora confirmada:',
    driver_arrival_time: 'Hora de recogida del conductor:',
    external_delivery: 'El pedido es entregado por un conductor externo de {{carrier}}',
  },
  products: {
    item: 'Artículo:',
  },
  discount_breakdown: {
    label: 'Descuento',
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Descuento porcentual por total aplicado',
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Descuento porcentual por productos aplicado',
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Descuento en importe por productos aplicado',
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Descuento en importe por total aplicado',
    [OFFER_KIND.BOGO]: 'Bogo aplicado',
    [OFFER_KIND.BOGO_HALF_PRICE]: 'Bogo al 50 % aplicado',
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Artículo gratis por productos aplicado',
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Artículo gratis por total aplicado',
    GiftCard: 'Tarjeta regalo aplicada',
    Reward: 'Puntos de fidelidad aplicados',
    CashbackAccount: 'Puntos de fidelidad aplicados',
    PromoCodeComponent: 'Promoción aplicada',
    Offer: 'Oferta aplicada',
  },
  payment_breakdown: {
    price: 'Precio:',
    subtotal: 'Subtotal',
    delivery_fee: 'Gastos de envío',
    tips: 'Propina',
    processing_fee: 'Tarifa de servicio en línea',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'Comisión PayPal',
    },
    tax: 'Impuestos',
    total: 'Total',
    paid_amount: 'Importe pagado',
    order_not_paid: 'El pedido aún no ha sido pagado',
    order_paid_online: 'Ya pagado en línea',
    cash: 'Pago en el local',
    this_is_not_an_invoice: 'Esto no es una factura',
  },
  delivery_qr_code: {
    scan: 'Escanea y entrega con Google Maps',
  },
  delivery_providers: {
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
};
